import clsx from 'clsx';
import React from 'react';

type FormFieldLabelProps = React.PropsWithChildren & React.LabelHTMLAttributes<HTMLLabelElement>;

export function FormFieldLabel({ children, ...rest }: FormFieldLabelProps) {
  return (
    <label
      {...rest}
      className={clsx('transition-all duration-200', 'block mb-8', 'text-on-surface text-16 text-left font-600')}
    >
      {children}
    </label>
  );
}
